import { Injectable } from '@angular/core';
import { IGeneralEntityService } from 'src/app/shared/services/contracts/general-entity.service';

import { Icd10Dto } from '../../models/icd10/icd10-dto.model';
import { Icd10ModelName } from '../../models/model-names';
import { Icd10Service } from './icd10.service';

/**
 * Entity-Service für ICD-10-GM Diagnosen.
 *
 * Implementiert IGeneralEntityService um in das bestehende
 * Autocomplete-Provider-System integriert zu werden. Die Suche
 * erfolgt lokal über den Icd10Service.
 *
 * @internal
 */
@Injectable({ providedIn: 'root' })
export class Icd10EntityService implements IGeneralEntityService {
  public restriction: any;

  public responsibleTypes: string[] = [Icd10ModelName];

  public type = Icd10ModelName;

  constructor(private readonly _icd10Service: Icd10Service) {}

  public isRestricted(): boolean {
    return false;
  }

  public clone(): IGeneralEntityService {
    return new Icd10EntityService(this._icd10Service);
  }

  public getAll(): Promise<Icd10Dto[]> {
    return Promise.resolve([]);
  }

  public find(id: string): Promise<Icd10Dto | null> {
    return this._icd10Service.findByCode(id);
  }

  public query(query: string): Promise<Icd10Dto[]> {
    return this._icd10Service.search(query);
  }
}
